import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  row: {
    justifyContent: 'flex-start',
    marginBottom: -3,
  },
  iconColumn: {
    width: 34,
    alignItems: 'center',
    position: 'relative',
  },
  halfBar: {
    width: 10,
    overflow: 'hidden',
  },
  fillBar: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: 10,
  },
  icon: {
    position: 'absolute',
    left: 0,
    zIndex: 2,
  },
  enableIcon: {
    position: 'absolute',
    left: -5,
    zIndex: 2,
  },
  contentContainer: {
    marginLeft: 12,
    justifyContent: 'center',
    flex: 1,
    paddingBottom: 10,
  },
  contentBox: {
    padding: 15,
    borderRadius: 7,
    borderWidth: 1,
  },
  imageStyle: {height: 44, width: 44, marginTop: 1},
  cancelImageStyle: {
    height: 44,
    width: 44,
    margin: -22,
  },
  iconStyle: {borderRadius: 50, padding: 5},
});
